import { queryClient } from "@/api/query-client";
import { Api } from "@Shared/schemas";

/** Mark all filter variants stale, including inactive lists revisited later. */
export function invalidateChallengeQueries() {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: [Api.Challenges.GetChallenges.Name] }),
    queryClient.invalidateQueries({ queryKey: [Api.Challenges.GetChallengeResults.Name] }),
  ]);
}
